var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0ZM7 12.6875C3.86367 12.6875 1.3125 10.1361 1.3125 7C1.3125 3.86395 3.86367 1.3125 7 1.3125C10.1363 1.3125 12.6875 3.86395 12.6875 7C12.6875 10.1361 10.1363 12.6875 7 12.6875ZM4.53516 10.6504L3.35104 9.46628L5.81686 7.00046L3.35156 4.53516L4.53567 3.35104L7.00098 5.81635L9.46645 3.35087L10.6506 4.53498L8.18509 7.00046L10.6511 9.46645L9.46697 10.6506L7.00098 8.18457L4.53516 10.6504Z",
    fill: "#8B93A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusReject);
export default __webpack_public_path__ + "static/media/status-reject.9e5043f82315f98eec2b59eb13f71ad1.svg";
export { ForwardRef as ReactComponent };